import React, { useState, useEffect } from "react";
import {
  Overlay,
  Modal,
  ModalHeader,
  ModalContent,
  ModalText,
  Select,
  Option,
  ButtonWrapper,
  CancelButton,
  ConfirmButton,
} from "./styled";
import { injectIntl } from "react-intl";

const ChangeStatusModal = (props) => {
  const { intl, numOfSelected, cancel, confirm, selected, runEffect, effects } =
    props;
  const [connection, setConnection] = useState();

  useEffect(() => {
    runEffect({
      source: "Components/Tickets/getConnectionsForSelectedTickets",
      effectId: "connectionsForSelectedTickets",
      context: { selectedTickets: selected },
    });
  }, [selected]);

  const connections = effects["connectionsForSelectedTickets"] || [];

  return (
    <Overlay>
      <Modal>
        <ModalHeader>
          {intl.formatMessage({ id: "ChangeStatusModal.changeStatus" })}
        </ModalHeader>
        <ModalContent>
          <ModalText>
            <strong>{numOfSelected}</strong>{" "}
            {intl.formatMessage({ id: "ChangeStatusModal.modalText" })}
          </ModalText>
          <Select
            value={connection}
            onChange={(e) => setConnection(e.target.value)}
          >
            <Option>
              {intl.formatMessage({ id: "ChangeStatusModal.selectConnection" })}
            </Option>
            {connections.map((connection) => (
              <Option key={connection.id} value={connection.name}>
                {connection.name}
              </Option>
            ))}
          </Select>
        </ModalContent>
        <ButtonWrapper>
          <CancelButton onClick={cancel}>
            {intl.formatMessage({ id: "Cancel" })}
          </CancelButton>
          <ConfirmButton onClick={() => confirm({ connection })}>
            {intl.formatMessage({ id: "ChangeStatusModal.changeStatus" })}
          </ConfirmButton>
        </ButtonWrapper>
      </Modal>
    </Overlay>
  );
};

export default injectIntl(ChangeStatusModal);
